module.exports = __webpack_public_path__ + "media/images/cv/teleg_logo-83b1bd6a5cf261f7a8c3416f9a7fcf56.png";